import { i18n } from "@lingui/core"
import { messages as en } from "@/locales/en/messages.po"
import { messages as esMX } from "@/locales/es-MX/messages.po"

// The locales the React app ships catalogs for. Keep in
// sync with `locales` in lingui.config.ts and
// `config.i18n.available_locales` on the Rails side. The
// values are BCP-47 tags (`es-MX`) to match the server's
// `I18n.locale.to_s`, shared as the Inertia `locale` prop.
export const SUPPORTED_LOCALES = ["en", "es-MX"] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

// `@lingui/vite-plugin` compiles these `.po` imports into
// runtime catalogs — no `lingui compile` step, mirroring the
// Ruby side's `type: :po`. See docs/translations.md.
i18n.load({
  en,
  "es-MX": esMX,
})

function isSupported(locale: string): locale is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
}

// Activate the locale the server resolved (from
// Accept-Language, shared as the Inertia `locale` prop).
// Falls back to English for any unrecognized/absent value so
// the UI always renders.
export function activateLocale(locale: string | undefined | null): void {
  i18n.activate(locale && isSupported(locale) ? locale : "en")
}

export { i18n }
